import React from 'react';
import { Stack, Typography } from '@mui/material';
import { SubTitle, Link } from '../../../common';
import Links from '../../../../constants/links';

const NoActiveDomains = () => (
  <Stack spacing={1}>
    <SubTitle>No active domains.</SubTitle>
    <Typography variant="body2">
      To enable your domain, please{' '}
      <Link href={Links.HELP_URL} target="_blank" rel="noopener">
        contact Showit support
      </Link>
      .
    </Typography>
  </Stack>
);

export default NoActiveDomains;
